import React from "react";
import {
  dateOnlyISOString,
  FormatDateFormat,
  formatDateRange,
  toUTCDate
} from "src/utils/date";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import { Language } from "src/utils/localization/languages/types";

interface CruiseDepartureArrivalDatesProps {
  departureDate: string | Date | undefined;
  arrivalDate: string | Date | undefined;
}

const CruiseDepartureArrivalDates: React.FC<
  React.PropsWithChildren<CruiseDepartureArrivalDatesProps>
> = ({
  departureDate: departureDateString,
  arrivalDate: arrivalDateString
}) => {
  const language = useLanguage();
  if (!departureDateString || !arrivalDateString) return null;

  const departureDate = toUTCDate(departureDateString);
  const arrivalDate = toUTCDate(arrivalDateString);

  const [formattedDepartureDate, formattedArrivalDate] =
    formatCruiseArrivalDepartureDate(departureDate, arrivalDate, language);

  return (
    <React.Fragment>
      <time dateTime={dateOnlyISOString(departureDate)}>
        {formattedDepartureDate}
      </time>
      <span aria-label="to">→</span>
      <time dateTime={dateOnlyISOString(arrivalDate)}>
        {formattedArrivalDate}
      </time>
    </React.Fragment>
  );
};

function formatCruiseArrivalDepartureDate(
  departureDate: Date,
  arrivalDate: Date,
  language: Language
): string[] {
  const format: FormatDateFormat = {
    year: "numeric",
    month: "short",
    day: "numeric"
  };
  return formatDateRange(departureDate, arrivalDate, language, format);
}

export default React.memo(
  CruiseDepartureArrivalDates,
  (prevProps, nextProps) =>
    prevProps.departureDate == nextProps.departureDate &&
    prevProps.arrivalDate == nextProps.arrivalDate
);
